import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

/** One year-end close attempt, as the server records it. */
export interface YearEndCloseDto {
  id:                          string;
  companyId:                   string;
  financialYearId:             string;
  yearCode:                    string;
  retainedEarningsAccountId:   string | null;
  retainedEarningsAccountCode: string;
  retainedEarningsAccountName: string;
  status:                      string;   // InProgress | Completed | Failed | RolledBack
  pnlNetBalance:               number;
  retainedEarningsTransferred: number;
  pnlClosingJournalId:         string | null;
  openingBalanceJournalId:     string | null;
  executedBy:                  string | null;
  executedDate:                string | null;
  completedBy:                 string | null;
  completedDate:               string | null;
  rolledBackBy:                string | null;
  rolledBackDate:              string | null;
  rollbackReason:              string | null;
  validationErrors:            string | null;
}

export interface ExecuteYearEndCloseRequest {
  financialYearId:             string;
  retainedEarningsAccountId:   string;
  retainedEarningsAccountCode: string;
  retainedEarningsAccountName: string;
}

export const yearEndCloseApi = {
  /** GET /api/v1/year-end-close — every close attempt for the company, newest first. */
  getList: () =>
    apiClient.get<ApiResponse<YearEndCloseDto[]>>('/year-end-close'),

  /** GET /api/v1/year-end-close/{id} */
  getById: (id: string) =>
    apiClient.get<ApiResponse<YearEndCloseDto>>(`/year-end-close/${id}`),

  /** POST /api/v1/year-end-close/execute — the route is /execute, not the collection. */
  execute: (data: ExecuteYearEndCloseRequest) =>
    apiClient.post<ApiResponse<YearEndCloseDto>>('/year-end-close/execute', data),

  /** POST /api/v1/year-end-close/{id}/rollback — the reason is required and is audited. */
  rollback: (id: string, reason: string) =>
    apiClient.post<ApiResponse<void>>(`/year-end-close/${id}/rollback`, { reason }),
};
